import React from 'react';

import { type SideNavigationItemProps } from '@lumapps/lumx-back-office/components/SideNavigation';
import { useSelector } from '@lumapps/redux/react';

import { isUserDirectoryEditAllowed } from '../../ducks/selectors';
import { UserDirectoriesSideNavigation as UserDirectoriesSideNavigationUI } from './UserDirectoriesSideNavigation';

export const UserDirectoriesSideNavigation: React.FC<Partial<SideNavigationItemProps>> = (props) => {
    const isAllowed = useSelector(isUserDirectoryEditAllowed);

    return <UserDirectoriesSideNavigationUI {...props} isAllowed={isAllowed} />;
};

UserDirectoriesSideNavigation.displayName = 'SideNavigationItem';
